import React, { useState } from 'react';
import { useEasybase } from 'easybase-react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@material-ui/core';

type AnmeldeAdminType = {
  rehasportName: string,
  sportarenaName: string;
};

const AnmeldeDialog:React.FC<AnmeldeAdminType> = (props) => {
  const {
    isUserSignedIn,
    signIn,
    signOut,
//    signUp,
  } = useEasybase();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [usernameValue, setUsernameValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");

  const onAuthButtonClick = () => {
    if (isUserSignedIn()) {
      signOut();
    } else {
      setDialogOpen(true);
    }
  }

  const onSignInClick = async () => {
    const res = await signIn(usernameValue, passwordValue);
    if (res.success) {
      setDialogOpen(false);
      setUsernameValue("");
      setPasswordValue("");
    }
  }

  // const onSignUpClick = async () => {
  //   const res = await signUp(usernameValue, passwordValue);
  //   if (res.success) {
  //     await signIn(usernameValue, passwordValue);
  //     setDialogOpen(false);
  //     setUsernameValue("");
  //     setPasswordValue("");
  //   }
  // }

  const handleClose = () => {
    setDialogOpen(false);
  };

  if (isUserSignedIn()) {
    return (
      <>
        {props.children}
        <Button variant="contained" onClick={onAuthButtonClick}>Abmelden</Button> 
      </>
    )
  } else return (
    <>
      <Box m={1}>
        <Button variant="contained" onClick={onAuthButtonClick}>Anmelden</Button>
      </Box>
      <Dialog open={dialogOpen} onClose={handleClose} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Anmeldung</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bitte die eMail-Adresse und das vereinbarte Kennwort angeben.
          </DialogContentText>
          <Box m={1}>
            <TextField label="eMail" value={usernameValue} onChange={e => setUsernameValue(e.target.value)} />
          </Box>
          <Box m={1}>
            <TextField label="password" value={passwordValue} type="password" onChange={e => setPasswordValue(e.target.value)} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onSignInClick}>Sign In</Button>
          <Button onClick={handleClose}>Abbrechen</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AnmeldeDialog;
